module.exports = __webpack_public_path__ + "img/app-switch-icon.cd65b7ae.png";